export const DefaultDateFormat: Readonly<Intl.DateTimeFormatOptions> = {};
